import React from 'react';

// Icône SVG pour "Flèche Droite"
const ArrowRightIcon = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
    {...props}
  >
    <line x1="5" y1="12" x2="19" y2="12"></line>
    <polyline points="12 5 19 12 12 19"></polyline>
  </svg>
);

// Icône SVG pour "Bouclier"
const ShieldCheckIcon = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
    {...props}
  >
    <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"></path>
    <path d="m9 12 2 2 4-4"></path>
  </svg>
);

export function HeroSection() {
  return (
    // On garde min-h-screen pour la flexibilité
    <section id="hero" className="relative min-h-screen flex items-center justify-center overflow-hidden">
      {/* Image de fond avec superposition */}
      <div className="absolute inset-0 z-0">
        <img
          src="https://www.deraking.fr/wp-content/uploads/2025/04/desinsectisation-blattes-cafards.jpg" // Assurez-vous d'avoir une image ici
          alt="Agent PestGuard en intervention"
          className="w-full h-full object-cover"
          onError={(e) => e.target.src = 'https://placehold.co/1920x1080/1a1a1a/cccccc?text=PestGuard+Intervention'}
        />
        {/* L'overlay semi-transparent */}
        <div className="absolute inset-0 bg-black/60"></div>
      </div>
      {/* Contenu */}
      {/* AJOUT: py-24 pour plus d'espace vertical global, pt-32 sur mobile pour pousser le contenu vers le bas */}
      <div className="relative z-10 container mx-auto px-4 sm:px-6 lg:px-8 text-center pt-32 pb-16 sm:py-24">
        <div className="max-w-4xl mx-auto">
          {/* Titre (taille mobile réduite) */}
          <h1 className="text-3xl sm:text-5xl lg:text-6xl font-bold text-white mb-6 text-shadow animate-fade-in-up">
            Solutions
            <span className="block text-primary"> sur mesure pour</span>
            <span className="block"> chaque besoin.</span>
          </h1>

          {/* Paragraphe (taille mobile réduite) */}
          <p className="text-base sm:text-lg text-gray-200 mb-8 max-w-2xl mx-auto animate-fade-in-up text-center" style={{ animationDelay: '0.2s' }}>
            Entreprise experte en lutte antiparasitaire, désinfection et protection contre les nuisibles.
            Nous assurons des interventions rapides, efficaces et respectueuses des normes de sécurité.
          </p>

          {/* Boutons CTA */}
          {/* AJOUT: mb-20 pour ajouter BEAUCOUP d'espace en dessous sur mobile */}
          <div className="flex flex-col sm:flex-row gap-4 justify-center animate-fade-in-up mb-20" style={{ animationDelay: '0.4s' }}>
            {/* Taille mobile réduite */}
            <button
              className="bg-primary hover:bg-primary/90 text-white px-6 py-2 text-base sm:px-8 sm:py-3 sm:text-lg font-semibold group transition-all rounded-lg"
              onClick={() => document.getElementById('contact')?.scrollIntoView({ behavior: 'smooth' })}
            >
              Contactez-nous
              <ArrowRightIcon className="inline-block ml-2 h-5 w-5 group-hover:translate-x-1 transition-transform" />
            </button>
            
            {/* Taille mobile réduite */}
            <button
              className="border border-white text-white hover:bg-white hover:text-gray-800 px-6 py-2 text-base sm:px-8 sm:py-3 sm:text-lg font-semibold group transition-all rounded-lg" // Changé hover:text-slate-blue en hover:text-gray-800
              onClick={() => document.getElementById('services')?.scrollIntoView({ behavior: 'smooth' })}
            >
              <ShieldCheckIcon className="inline-block mr-2 h-5 w-5 group-hover:scale-110 transition-transform" />
              Voir nos services
            </button>
          </div>
          {/* Pas d'indicateur de souris */}
        </div>
      </div>

      {/* Statistiques */}
      {/* Positionné en bas, avec padding pour l'espace */}
      <div className="absolute bottom-0 left-4 right-4 z-10 pb-4">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-4 max-w-4xl mx-auto">
          {/* Blocs de stats (taille mobile réduite) */}
          <div className="bg-white/10 backdrop-blur-sm rounded-lg p-3 sm:p-4 text-center text-white">
            <div className="text-xl sm:text-2xl font-bold text-primary">1000+</div>
            <div className="text-xs sm:text-sm">Interventions</div>
          </div>
          <div className="bg-white/10 backdrop-blur-sm rounded-lg p-3 sm:p-4 text-center text-white">
            <div className="text-xl sm:text-2xl font-bold text-primary">3+</div>
            <div className="text-xs sm:text-sm">Années d'expérience</div>
          </div>
          <div className="bg-white/10 backdrop-blur-sm rounded-lg p-3 sm:p-4 text-center text-white">
            <div className="text-xl sm:text-2xl font-bold text-primary">99%</div>
            <div className="text-xs sm:text-sm">Clients satisfaits</div>
          </div>
          <div className="bg-white/10 backdrop-blur-sm rounded-lg p-3 sm:p-4 text-center text-white">
            <div className="text-xl sm:text-2xl font-bold text-primary">100%</div>
            <div className="text-xs sm:text-sm">Produits certifiés</div>
          </div>
        </div>
      </div>
    </section>
  );
}